"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterSimilarItems = exports.itemDetailsFunc = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _helpers = require("../../helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CancelToken = _axios["default"].CancelToken;
var cancel;

var itemDetailsFunc = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var env, item, setItemDetails, cancelToken, id, accountNumber, partNumber, result, Description, SpecTable;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            env = _ref.env, item = _ref.item, setItemDetails = _ref.setItemDetails;
            if (cancel) cancel();
            cancelToken = new CancelToken(function (token) {
              return cancel = token;
            });
            console.log(item);
            id = item.supplier.Id;
            accountNumber = item.supplier.AccountNumber;
            partNumber = item.SupplierPartNumber;
            _context.next = 9;
            return (0, _helpers.getItemDetails)({
              env: env,
              id: id,
              accountNumber: accountNumber,
              partNumber: partNumber,
              cancelToken: cancelToken
            });

          case 9:
            result = _context.sent;
            Description = result.fetchedData.Description || item.Description;
            SpecTable = result.fetchedData.SpecTable || item.SpecTable;
            setItemDetails(_objectSpread(_objectSpread({}, item), {}, {
              Description: Description,
              SpecTable: SpecTable
            }));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function itemDetailsFunc(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.itemDetailsFunc = itemDetailsFunc;

var filterSimilarItems = function filterSimilarItems(_ref3) {
  var origItem = _ref3.origItem,
      allItems = _ref3.allItems,
      isAvailable = _ref3.isAvailable,
      searchTerm = _ref3.searchTerm,
      setSimilarItems = _ref3.setSimilarItems,
      filterItems = _ref3.filterItems,
      config = _ref3.config;
  var similarItems = filterItems(allItems, {
    isAvailable: isAvailable,
    searchTerm: searchTerm
  });
  similarItems = tallyKeyTerms(similarItems, origItem);
  similarItems = topForEachSup(similarItems, {
    topNum: 2,
    supplierIds: config.suppliers,
    origItem: origItem
  });
  similarItems = (0, _helpers.sortByPrice)(similarItems);
  setSimilarItems(similarItems);
};

exports.filterSimilarItems = filterSimilarItems;

var tallyKeyTerms = function tallyKeyTerms(itemsArr, origItem) {
  var origTerms = origItem.Name.split(/[,]|\s/g);
  return itemsArr.map(function (item) {
    var itemTerms = _lodash["default"].intersection(item.Name.split(/[,]|\s/g), origTerms);

    return _objectSpread(_objectSpread({}, item), {}, {
      simTermCount: itemTerms.length
    });
  });
};

var topForEachSup = function topForEachSup(itemsArr, _ref4) {
  var topNum = _ref4.topNum,
      supplierIds = _ref4.supplierIds,
      origItem = _ref4.origItem;
  var supplierItems = supplierIds.map(function (id) {
    var arr = [];
    itemsArr.forEach(function (item) {
      if (item.supplier.Id === id && item.SupplierPartNumber !== origItem.SupplierPartNumber) {
        arr.push(item);
      }
    });
    return arr;
  });
  var filteredItems = supplierItems.map(function (arr) {
    var sortedArr = sortByTermCount(arr);
    return _lodash["default"].slice(sortedArr, 0, topNum);
  });
  var newItemsArray = [];
  filteredItems.forEach(function (arr) {
    return newItemsArray = newItemsArray.concat(arr);
  });
  return newItemsArray;
};

var sortByTermCount = function sortByTermCount(array) {
  var sortedArr = [];
  array.forEach(function (item) {
    if (sortedArr.length === 0) return sortedArr.push(item);

    var index = _lodash["default"].sortedIndexBy(sortedArr, item, 'simTermCount');

    sortedArr.splice(index, 0, item);
  });
  return _lodash["default"].reverse(sortedArr);
};